var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOr)?_c('div',{staticClass:"mat-header"},[_c('h2',[_vm._v("管理会计师专业能力(PCMA)初级考试报名系统")]),_vm._v(" "),_c('div',[_vm._v("您好， "+_vm._s(_vm.$store.state.UserInfo.userName || _vm.userInfo.userName)+"！"),_c('span',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v(" 退出 ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a89a738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MatHeader.vue
// module id = null
// module chunks = 